export default __webpack_public_path__ + "static/media/ForwardButton.cf37f1f7.svg";